import {ITeamsTeamcenterLoggerSeverityLevel, ITeamsTeamcenterLoggerSeverityLevelType} from './ITeamsTeamcenterLoggerSeverityLevel'
import {ITeamsTeamcenterLoggerConfiguration} from './ITeamsTeamcenterLoggerConfiguration'

export class TeamsTeamcenterLoggerConfiguration implements  ITeamsTeamcenterLoggerConfiguration 
{
    logLevel: ITeamsTeamcenterLoggerSeverityLevelType  = ITeamsTeamcenterLoggerSeverityLevel.Information;
    logConsole: boolean = true;
    logApplicationInsightsConnectionString: string = "";    
}
